import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { DvDynamicFormElement } from '@devinco/ui/legacy';
import {
  DvCheckboxElement,
  DvDateTimePickerElement,
  DvNumberboxElement,
  DvSpaceElement,
  DvTextareaElement,
  DvTextboxElement,
} from '@devinco/ui/legacy';

@Injectable()
export class VehicleMileageTabService {
  elements: DvDynamicFormElement[] = [
    new DvNumberboxElement({
      colspan: 6,
      disabled: true,
      key: 'Mileage',
      label: 'VehicleMileageTab.Km',
    }),
    new DvDateTimePickerElement({
      colspan: 6,
      key: 'MileageLastAdjustment',
      label: 'VehicleMileageTab.SelectDateTime',
    }),
    new DvNumberboxElement({
      colspan: 6,
      extra: { ignoreInRequest: true },
      key: 'adjustedMileage',
      label: 'VehicleMileageTab.AdjustedMileage',
      validators: [Validators.required],
    }),
    new DvNumberboxElement({
      colspan: 6,
      disabled: true,
      extra: { ignoreInRequest: true },
      key: 'mileageDifference',
      label: 'VehicleMileageTab.Difference',
    }),
    new DvTextboxElement({
      colspan: 6,
      key: 'description',
      extra: { ignoreInRequest: true },
      label: 'VehicleMileageTab.Description',
    }),
    new DvSpaceElement({ colspan: 6 }),
    new DvCheckboxElement({
      checkboxLabel: 'VehicleMileageTab.KmOnStartup',
      extra: { ignoreInRequest: true },
      key: 'mileageOnStartup',
      disabled: true,
    }),
    new DvTextareaElement({
      key: 'ShowRecord',
      hidden: true,
    }),
  ];
}
